import 'next/javascripts/modules/polyfills';
import 'javascripts/application';
import 'stylesheets/application';
import 'images';
import 'audios';